export default "__VITE_ASSET__BEodCyP$__"